<template>
    <v-hover v-slot="{ hover }">
        <v-card :elevation="hover ? 6 : 2">
            <v-card-text>
                <div ref="chart" style="width: 100%;height:350px;"></div>
            </v-card-text>
        </v-card>
    </v-hover>

</template>
<script>
import * as echarts from 'echarts';

export default {
    props: {
        update: {
            type: Boolean
        },
        axis: {
            type: Array
        },
        max: {
            type: Array
        },
        min:{
            type: Array
        },
        avg: {
            type: Array
        },
    },
    watch: {
        update() {
            setTimeout(() => {
                this.myChart.resize()
            }, 80);
        },
        axis(value) {
            this.myChart.setOption({
                xAxis: {
                    data: value
                },
                series: [
                    {
                        name: 'Average',
                        type: 'bar',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.avg
                    },
                    {
                        name: 'Minimum',
                        type: 'line',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.min
                    },
                    {
                        name: 'Maximum',
                        type: 'line',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.max
                    }
                ]
            });
            this.myChart.resize()
        }
    },
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                    }
                },
                toolbox: {
                    itemGap: 20,
                    show: true,
                    showTitle: false, // hide the default text so they don't overlap each other
                    feature: {
                        restore: { show: true },
                        magicType: {
                            type: ['line', 'bar']
                        },
                        saveAsImage: {
                            show: true,
                            title: 'Save As Image'
                        },
                        dataView: {
                            show: true,
                            title: 'Data View'
                        },
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Level (cm.)',
                        axisLabel: {
                            formatter: '{value} cm.'
                        }
                    }
                ],
                series: []
            }
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.chart);
        const resizeObserver = new ResizeObserver((entries) => {
            this.myChart.resize();
        });
        resizeObserver.observe(this.$refs.chart);
        this.myChart.setOption(this.option);
    },
}

</script>